<template>
	<div style="text-align: left; padding: 1px; width: 100%; height: 915px; overflow-y: auto;"> <!-- 新增浮云容器 -->
		<el-table :data="tableData" border style="width: 100%">
			<el-table-column prop="name" label="姓名">
				<template slot-scope="scope">
					{{ scope.row.name }}
				</template>
			</el-table-column>
			<el-table-column prop="createTime" label="申请时间">
			</el-table-column>
			<el-table-column prop="updateTime" label="通过时间">
			</el-table-column>
			<el-table-column prop="telephone" label="联系电话">
			</el-table-column>
			<el-table-column prop="companyName" label="所属企业">
			</el-table-column>

			<el-table-column prop="typeName" label="想了解的产品">
			</el-table-column>

			<el-table-column prop="status" label="使用状态">
				<template slot-scope="scope">
					<el-tag v-if="scope.row.status === '0'" type="info">待处理</el-tag>
					<el-tag v-else-if="scope.row.status === '1'" type="success">已通过</el-tag>
					<el-tag v-else type="danger">已拒绝</el-tag>
				</template>
			</el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button @click="handleClick(scope.row, '1')" type="primary" size="small" v-if="scope.row.status === '0'">通过</el-button>
				</template></el-table-column>
		</el-table>
	</div>
</template>

<script>
import { userRegisterList, userRegisterUpdate } from '@/public/api.js'

// 引入路由实例
export default {
	name: 'register',
	components: {

	},
	data() {
		return {
			formData: [], // 改为数组类型，确保Vue能正确追踪变化
			tableData: []
		}
	},
	mounted() {
		this.getList();
		setInterval(() => {
			this.getList();
		}, 10000);
	},
	methods: {
		getList() {
			let that = this;
			userRegisterList({ status: '0', telephone: '' }).then(res => {
				that.tableData = res.data.rows.reverse();
			})
		},
		// 处理注册信息更新
		handleClick(item, status) {
			let that = this;
			item.status = status;
			// 提交数据到后端
			userRegisterUpdate(item).then(res => {
				if (res.data.code !== 200) {
					that.$message.error(res.data.message);
				} else {
					that.$message.success('修改成功');
					that.getList();
				}
			})
		},
		getMinutesDifference(timeString) {
			const targetTime = new Date(timeString);

			if (isNaN(targetTime.getTime())) {
				throw new Error("无效的时间字符串");
			}

			const now = new Date();
			const diffMs = targetTime - now;
			const diffMinutes = Math.round(diffMs / (1000 * 60));

			return diffMinutes;
		}
	}
}
</script>
<style scoped>
.box-card {
	margin-bottom: 10px;
}

.header {
	padding: 10px;
	background-color: #f5f5f5;
	border-bottom: 1px solid #e5e5e5;
	margin-bottom: 5px;
}

.text.item {
	background-color: #f9f9f9;
	/* 设置浅灰色背景 */
	padding: 15px;
	border-radius: 4px;

	/* 设置禁用输入框的背景颜色为白色 */
	.el-input.is-disabled .el-input__inner {
		background-color: #ffffff !important;
	}
}
</style>